import { render, staticRenderFns } from "./loseDialog.vue?vue&type=template&id=4bb3d8cc&scoped=true"
import script from "./loseDialog.vue?vue&type=script&lang=ts"
export * from "./loseDialog.vue?vue&type=script&lang=ts"
import style0 from "./loseDialog.vue?vue&type=style&index=0&id=4bb3d8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3d8cc",
  null
  
)

export default component.exports